export const menuItems: { text: string }[] = [
	{ text: 'Apps' },
	{ text: 'Wearables' },
	{ text: 'Devices' },
	{ text: 'Services' },
	{ text: 'Sources' },
]
